const TECH_ICON_LABELS = {
  'react.png': 'React',
  'tailwind.png': 'Tailwind CSS',
  'Typescript_logo_2020.svg.png': 'TypeScript',
  'AdonisJS.png': 'AdonisJS',
  'Postgresql_elephant.svg.png': 'PostgreSQL',
  'railway.png': 'Railway',
  'stripe.png': 'Stripe',
  'cloudflare.webp': 'Cloudflare',
  'Amazon-S3-Logo.svg.png': 'Amazon S3',
  'resend.webp': 'Resend',
  'twilio.svg': 'Twilio',
  'zendesk.png': 'Zendesk',
  'node-cron.png': 'Node Cron',
  'jest.png': 'Jest',
  'playwright-logo.svg': 'Playwright',
  'japa.png': 'Japa',
  'tanstack.png': 'TanStack',
  'zustand.png': 'Zustand',
  'Redis.png': 'Redis',
  'Cloudflare_Turnstile_logo.svg': 'Cloudflare Turnstile',
  'grafana.png': 'Grafana',
  '3js-logo.png': 'Three.js',
  'react-3d-fiber-logo.png': 'React Three Fiber',
  'c.png': 'C',
  'clang.png': 'Clang',
  'next.png': 'Next.js',
  'vercel.svg': 'Vercel',
  'prisma.png': 'Prisma',
  'html.png': 'HTML',
  'css.png': 'CSS',
  'js.png': 'JavaScript',
  'firebase.png': 'Firebase',
  'fast-api.png': 'FastAPI',
  'expo.png': 'Expo',
  'mongo.png': 'MongoDB',
  'node.png': 'Node.js',
};

export function getTechIconLabel(iconPath) {
  const filename = iconPath.split('/').pop();
  return (
    TECH_ICON_LABELS[filename] ||
    filename
      .replace(/\.[^.]+$/, '')
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
}
